import { render } from "./ManageCategories.vue?vue&type=template&id=69ae0648"
import script from "./ManageCategories.vue?vue&type=script&lang=js"
export * from "./ManageCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__